import React from 'react';

import { TitleContainer } from '@components/Title/Title.styled';
import { TitleProps } from './Title.types';

export const Title = ({ text, ...styles }: TitleProps) => (
  <TitleContainer {...styles}>{text}</TitleContainer>
);
